import ChangePassword from './ChangePassword';
import DeleteAccount from './DeleteAccount';

export default function AccountSettings(props) {
  return (
    <>
      {props.selected === 0 && <ChangePassword />}
      {props.selected === 1 && <DeleteAccount />}
    </>
  );
}
